import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer role="contentinfo" className="site-footer">
      <div className="social-icons">
        <a
          href="https://www.linkedin.com/in/alamoudison/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn profile of Abdulrahman Alamoudi"
        >
          <img src="/assets/linkedin.png" alt="LinkedIn" />
        </a>
        <a
          href="https://x.com/Alamoudison"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter profile of Abdulrahman Alamoudi"
        >
          <img src="/assets/x.png" alt="Twitter (X)" />
        </a>
        <a
          href="https://www.instagram.com/alamoudison/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram profile of Abdulrahman Alamoudi"
        >
          <img src="/assets/instagram.png" alt="Instagram" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61576753760415"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook profile of Abdulrahman Alamoudi"
        >
          <img src="/assets/facebook.png" alt="Facebook" />
        </a>
        <a
          href="https://wa.me/966546868946"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp chat with Abdulrahman Alamoudi"
        >
          <img src="/assets/whatsapp.png" alt="WhatsApp" />
        </a>
        <a
          href="https://www.youtube.com/channel/UC4W3f5Z8BkZ-atqB0UNmHew"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube channel of Abdulrahman Alamoudi"
        >
          <img src="/assets/youtube-v2.png" alt="YouTube" />
        </a>
        <a
          href="http://alamoudison.unaux.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Personal website of Abdulrahman Alamoudi"
        >
          <img src="/assets/website.png" alt="Website" />
        </a>
        <a
          href="mailto:alamoudison@gmail.com"
          aria-label="Email Abdulrahman Alamoudi"
        >
          <img src="/assets/email.png" alt="Email" />
        </a>
                <a
          href="https://github.com/alamoudison"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub profile of Abdulrahman Alamoudi"
        >
          <img src="/assets/github.png" alt="GitHub" />
        </a>

      </div>
      <p>© 2026 Abdulrahman Alamoudi. All rights reserved.</p>
    </footer>
  );
}

export default Footer;